import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Collapse, Modal, Button, Drawer } from 'antd';
import { CollapseDown, CollapseUp, Facebook, Instagram, Linkedin, LogoFull, Twitter, CloseIcon } from '../../assets/icons';
import './MarketFooter.scss';
import useMediaQuery from '../../Hooks/useMediaQuery';
import SuccessModal from '../SuccessModal/SuccessModal';
import { Images } from '../../config/images';

import SellPropertyForm from '../../components/SellPropertyForm/SellPropertyForm';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { BUILD_VERSION, REALBRICKS_ADDRESS } from '../../utils/constant';

const { Panel } = Collapse;

const MarketFooter = (props) => {
  const screenMD = useMediaQuery('(min-width: 1000px)');

  const [isSellPropertyForm, setSellPropertyForm] = useState(false);
  const hideSellPropertyForm = () => {
    setSellPropertyForm(false);
  };
  const [successModal, setSuccessModal] = useState(false);
  const showSuccessModal = () => {
    setSuccessModal(true);
    setSellPropertyForm(false);
  };
  const hideSuccessModal = () => {
    setSuccessModal(false);
  };
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className='marketfooter'>
        <div className='container-fluid'>
          <div className='marketfooter__header'>
            <LogoFull verticalAlign='middle' />
            <ul className='nav'>
              <li>
                <a className='cursor-pointer' href={'tel:986 219 5819'} onClick={''}>
                986 219 5819
                </a>
              </li>
              <li>
                <Link to={'/legal'}>Legal</Link>
              </li>
               <li>
                <a href='https://www.realbricks.com/offering-circular'>Offering Circular</a>
              </li>
                {process.env.REACT_APP_WEBFLOW_LOGIN !== 'production' && (
                  <li>
                    {BUILD_VERSION}
                  </li>
                )}
            </ul>
            <ul className='social'>
              <li>
                <a target='_blank' rel='noopener noreferrer' href='https://twitter.com/Realbricksapp'>
                  <Twitter verticalAlign='middle' />
                </a>
              </li>
              <li>
                <a target='_blank' rel='noopener noreferrer' href='https://www.linkedin.com/company/realbricks/'>
                  <Linkedin verticalAlign='middle' />
                </a>
              </li>
              <li>
                <a target='_blank' rel='noopener noreferrer' href='https://www.facebook.com/profile.php?id=100089231980296'>
                  <Facebook verticalAlign='middle' />
                </a>
              </li>
              <li>
                <a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/realbricksapp/'>
                  <Instagram verticalAlign='middle' />
                </a>
              </li>
            </ul>
          </div>
          <div className='marketfooter__content'>
            <p>© {currentYear} Realbricks</p>
            <Collapse
              defaultActiveKey={['1']}
              ghost
              expandIconPosition='end'
              expandIcon={({ isActive }) => (isActive ? <CollapseDown width='15' /> : <CollapseUp width='15' />)}
            >
              <Panel header='Important Information' key='1'>
                <p>
                  {' '}
                  Terra Mint Group, Corp ("Terra Mint"), as the Managing Member of Neptune REM, LLC ("Neptune") operates the RealBricks.com website (the "Site") and is not a broker-dealer or investment advisor. All securities related activity is conducted through Dalmore Group LLC, a registered broker-dealer and member of FINRA/SIPC, located at 525 Green Pl. Woodmere, NY 11598. You can review the brokercheck for Dalmore. An up-to-date Dalmore Form CRS is available.
                </p>
                <p>
                  You should speak with your financial advisor, accountant and/or attorney when evaluating any offering. Neither Terra Mint, Neptune, nor Dalmore makes any recommendations or provides advice about investments, and no communication, through this website or in any other medium, should be construed as a recommendation for any security offered on or off this investment platform. The Site may make forward-looking statements. You should not rely on these statements but should carefully evaluate the offering materials in assessing any investment opportunity, including the complete set of risk factors that are provided as part of the offering circular for your consideration.
                </p>
                <p>
                  Neptune is conducting public offerings pursuant to Regulation A, as amended, through the Site. The most current offering circular for Neptune is available here. Past performance is no guarantee of future results. Investments such as those on the Realbricks platform are speculative and involve substantial risks to consider before investing. These risks are outlined in the respective offering materials and including, but not limited to, illiquidity and a complete loss of capital. Key risks include, but are not limited to, limited operating history, reliance on key personnel, inherent risks in investing in real estate, dividends may not be received on predictable schedule and or at all by Investors, and lack of voting rights. Also, the adverse economic effects of the COVID-19 pandemic remain unknown and could materially impact this investment. An investment in an offering constitutes only an investment in a particular series and not in the underlying asset(s). Investors should carefully review the risks located in the respective offering materials for a more comprehensive discussion of risk.
                </p>
                <p>
                  From time to time, Neptune may undertake "testing the waters" for additional series of securities to be offered pursuant to Regulation A. For offerings that have not yet been qualified, no money or other consideration is being solicited, and if sent in response, will not be accepted.
                </p>
                <p>
                  NO MONEY OR OTHER CONSIDERATION IS BEING SOLICITED, AND IF SENT IN RESPONSE, WILL NOT BE ACCEPTED.
                </p>
                <p>
                  NO OFFER TO BUY THE SECURITIES CAN BE ACCEPTED AND NO PART OF THE PURCHASE PRICE CAN BE RECEIVED UNTIL THE OFFERING STATEMENT FILED BY THE COMPANY WITH THE SEC HAS BEEN QUALIFIED BY THE SEC. ANY SUCH OFFER MAY BE WITHDRAWN OR REVOKED, WITHOUT OBLIGATION OR COMMITMENT OF ANY KIND, AT ANY TIME BEFORE NOTICE OF ACCEPTANCE GIVEN AFTER THE DATE OF QUALIFICATION.
                </p>
                <p>
                  AN INDICATION OF INTEREST INVOLVES NO OBLIGATION OR COMMITMENT OF ANY KIND.
                </p>
                <p>
                  AN OFFERING STATEMENT REGARDING THIS OFFERING HAS BEEN FILED WITH THE SEC. YOU MAY OBTAIN A COPY OF THE PRELIMINARY OFFERING CIRCULAR THAT IS PART OF THAT OFFERING STATEMENT FROM: {REALBRICKS_ADDRESS} OR <a href='https://www.sec.gov/Archives/edgar/data/1992001/000110465923116338/xsl1-A_X01/primary_doc.xml' style={{ color: 'white' }}><b><u>HERE</u></b></a>
                </p>
                <p>
                  Investment overviews contained herein contain summaries of the purpose and the principal business terms of the investment opportunities. Such summaries are intended for informational purposes only and do not purport to be complete, and each is qualified in its entirety by reference to the more-detailed discussions contained in the respective offering circular filed with the SEC.
                </p>
                <p>
                  Realbricks does not offer refunds after an investment has been made. Please review the relevant offering materials and subscription documentation for more information.
                </p>
                <p>
                  Potential investors should not rely on any forward-looking statements regarding any investment opportunity, which is based on our beliefs and information currently available to us. The words “anticipate,” “believe,” “expect,” “aim,” “potential,” “design,” “target,” “intend,” “may,” “might,” “plan,” “estimate,” “project,” “projection,” “should,” “will,” “would,” “result” and similar expressions identify forward-looking statements. Such statements are subject to risks, uncertainties, and assumptions and are not guarantees of future performance, which may be affected by known and unknown risks, trends, uncertainties, and factors that are beyond our control. These risks could result in the loss of your investment. See the offering materials for detailed information.
                </p>
                <p>
                  Neptune does not have a public trading market for its Series Interests. While it intends to seek a quotation on PPEX, an alternative trading system (ATS) operated by North Capital Investment Technology, Inc. (“PPEX”) with a view to providing our holders of Series Interests with potential liquidity in the form of a secondary market for their investment in our Series Interests. However, there can be no guarantee that a secondary market may develop, or if it does, as to the volume or pricing with respect to any secondary trading that might develop. The PPEX does not employ market makers to provide liquidity, unlike national securities exchanges. Until Neptune’s Series Interests are listed, if ever, you may not sell the company’s Series Interests. Therefore, it may be difficult for you to sell Neptune’s Series Interests at the time you wish to do so, if you are able to sell them at all. If you are able to sell your Series Interests, you may have to sell them at a substantial discount to their public offering price. Because of the illiquid nature of our Series Interests, you should purchase Neptune’s Series Interests only as a long-term investment and be prepared to hold them for an indefinite period of time.
                </p>
                <p>
                  Property information shown has been provided from various sources, which can include the seller and/or public records. It is believed reliable but not guaranteed and should not be relied upon without independent verification.
                </p>
                <p>
                  Disclaimer: Images, Information and Floor Plan and Measurements are approximate and are for illustrative purposes only. We make no guarantee, warranty or representation as to the accuracy and completeness of the floor plans, measurements and or any information provided. You or your advisers should conduct a careful, independent investigation of the property to determine to your satisfaction as to the suitability of the property for your space requirements. All pricing and availability is subject to change. The information is to be used as a point of reference and not a binding agreement.
                </p>
              </Panel>
            </Collapse>
          </div>
          <div className='marketfooter__contact'>
            <div>
              <span>Email:</span>
              <a href='mailto:support@realbricks.com'>support@realbricks.com</a>
            </div>
          </div>
        </div>
      </div>
      {screenMD && (
        <>
          {isSellPropertyForm && (
            <Modal
              className=''
              open={isSellPropertyForm}
              onCancel={hideSellPropertyForm}
              header={false}
              footer={false}
              width={524}
              closeIcon={<CloseIcon />}
              centered
              desktopModal
              maskClosable={false}
              keyboard={false}
            >
              <SellPropertyForm onSubmitSuccess={showSuccessModal} />
            </Modal>
          )}
          {successModal && (
            <SuccessModal
              setOpen={successModal}
              setClose={hideSuccessModal}
              title='Thank you for your interest.'
              description='A Realbricks team member will reach out to you soon so we can gather more information about your property. '
              buttonText='Done'
              setDone={hideSuccessModal}
            />
          )}
        </>
      )}
      {isSellPropertyForm && !screenMD && (
        <Drawer
          className='footer-shadow quickbuy--drawer'
          width='100%'
          title={<p className='subhead-2 mb-0 ml-40 text-center'>Sell your property</p>}
          onClose={hideSellPropertyForm}
          open={isSellPropertyForm}
          closeIcon={<CloseIcon />}
          footer={false}
        // footer={
        //   <Button type='primary' className='w-100' onClick={showSuccessModal}>
        //     Submit
        //   </Button>
        // }
        >
          <SellPropertyForm onSubmitSuccess={showSuccessModal} />
        </Drawer>
      )}
      {successModal && (
        <Drawer
          className='success footer-shadow quickbuy--drawer'
          width='100%'
          title={false}
          onClose={hideSuccessModal}
          open={successModal}
          closeIcon={<CloseIcon />}
          footer={false}
        >
          <div className='mb-16 success__vector'>
            <LazyLoadImage src={Images.success} alt='success vector art' />
          </div>
          <h4 className='success__title fz-24'>Thank you for your interest.</h4>
          <p className='mb-48 text-taupe fz-16'>
            A Realbricks team member will reach out to you soon so we can gather more information about your property.{' '}
          </p>
          <Button type='primary' className='w-100' onClick={hideSuccessModal}>
            Done
          </Button>
        </Drawer>
      )}
    </>
  );
};

export default MarketFooter;
